export default __webpack_public_path__ + "static/media/tick.8bc6725d.svg";